// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sN1wi","placeholdersHeader":"styles_placeholdersHeader__3EiDE","editorStyle":"styles_editorStyle__-m5Xs","placeholdersBox":"styles_placeholdersBox__3D60e"};